import React from 'react';
import { Button, Dialog } from '@biq/apex-ui';
import { DialogActions, DialogContent, Typography } from '@mui/material';
import {
    HELP_DESK_SUPPORT_URL,
    HelpDeskModalProps,
    helpDeskModalStyles,
} from './help-desk-modal-helper';

export const HelpDeskModal = ({
    onClose,
}: HelpDeskModalProps): React.JSX.Element => {
    const handleClose = (): void => {
        onClose();
    };

    const handleOpenButton = (): void => {
        window.open(HELP_DESK_SUPPORT_URL, '_blank');
        handleClose();
    };

    return (
        <Dialog
            open={true}
            closable={true}
            onClose={handleClose}
            sx={helpDeskModalStyles.root}
            title={'BurstIQ Help Desk'}
        >
            <DialogContent sx={helpDeskModalStyles.dialogContentContainer}>
                <Typography sx={helpDeskModalStyles.dialogContentText}>
                    You are opening a new tab to the BurstIQ Help
                    <br />
                    Desk. A Help Desk account is required to submit
                    <br />
                    issues, bugs, questions, or enhancement requests.
                    <br />
                    If you do not have a Help Desk account, contact
                    <br />
                    an admin at your organization.
                    <br />
                    <br />
                    {
                        <Typography
                            sx={helpDeskModalStyles.dialogContentNoteText}
                        >
                            Note: Only select representatives have access.
                        </Typography>
                    }
                </Typography>
            </DialogContent>
            <DialogActions sx={helpDeskModalStyles.dialogActionContainer}>
                <Button
                    autoFocus
                    onClick={handleOpenButton}
                    color='primary'
                    variant='contained'
                    size='small'
                    sx={helpDeskModalStyles.openButton}
                >
                    OPEN IN NEW TAB
                </Button>
                <Button
                    size='small'
                    variant='text'
                    onClick={handleClose}
                    sx={helpDeskModalStyles.closeButton}
                >
                    GO BACK
                </Button>
            </DialogActions>
        </Dialog>
    );
};
